import NombaseWordmark from "@/components/NombaseWordmark";

export default function SetupNotice() {
  return (
    <div className="min-h-screen w-full bg-[#F7F8FA] flex flex-col items-center justify-center px-6 py-10" data-testid="setup-notice-page">
      <div className="mb-10"><NombaseWordmark size="md" variant="light" /></div>
      <div className="max-w-xl w-full border border-[#E2E8F0] rounded-[14px] p-8 bg-white text-center">
        <span className="text-[11px] font-medium uppercase tracking-[0.18em] text-[#64748B]">Configuration required</span>
        <h2 className="mt-3 text-2xl font-semibold tracking-tight text-[#0F172A]">Add your Clerk publishable key</h2>
        <p className="mt-3 text-sm text-[#64748B]">
          Set <code className="font-mono text-[#0F172A] bg-[#F1F5F9] px-1.5 py-0.5 rounded">REACT_APP_CLERK_PUBLISHABLE_KEY</code> in <code className="font-mono text-[#0F172A] bg-[#F1F5F9] px-1.5 py-0.5 rounded">/app/frontend/.env</code>, then restart the frontend.
        </p>
      </div>
    </div>
  );
}
